// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.sidemenu {
  position:fixed;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    z-index: 1000;
  }

  .sidemenu__header {
    background: #A0A0A0;
    color: white;
    border-bottom: rgb(80, 80, 80) solid 0.5px;
  }

  .logout-btn { 
    display: inline-block;
    outline: 0;
    cursor: pointer;
    border: 1px solid #1d1c1d4d;
    font-weight: 700;
    background: #E7E8E8;
    padding: 0 8px 1px;
    border-radius: 26px;
    font-size: 13px;
    border: 1px solid #D4D3E8;
    color: var(--main-sub-color);
    text-transform: uppercase;
    box-shadow: 0px 2px 2px var(--main-sub-color);
    height: 28px;
    min-width: 56px;
    transition: .2s;
    margin-right: 10px;
  }
  .logout-btn:hover{
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);
        background: rgba(248,248,248,1);
    }

  .sidemenu__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: var(--header-color);
    padding-left: 10px;
    padding-right: 10px;
  }
  .card {
    position: relative;
    background: var(--header-card-color);
    width: 300px;
    border-radius: 6px;
    padding: 2rem;
    color: var(--header-card-text-color);
    box-shadow: 0 .25rem .25rem rgba(0,0,0,0.2),
      0 0 1rem rgba(0,0,0,0.2);
    overflow: hidden;
    box-sizing: border-box;
    line-height: 1.5;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", 
  Helvetica, Arial, "Lucida Grande", sans-serif;
  }

  img {
    max-width: 100%;
  }
    .card__image-container {
      margin: -2rem -2rem 1rem -2rem;
    }
    
    .card__line {
    opacity: 0;
    animation: LineFadeIn .8s .8s forwards ease-in;
    }
  
    .card__image {
      opacity: 0;
      animation: ImageFadeIn .8s 1.4s forwards;
    }
  
    .card__title {
      color: var(--header-card-text-color);
      margin-top: 0;
      font-weight: 800;
      letter-spacing: 0.01em;
    }
    
    .card__content {
      margin-top: -1rem;
      opacity: 0;
      animation: ContentFadeIn .8s 1.6s forwards;
    }
    
    .card__svg {
      position: absolute;
      left: 0;
      top: 115px;
    }
  
  
  @keyframes LineFadeIn {
    0% { opacity: 0; d: path("M 0 300 Q 0 300 0 300 Q 0 300 0 300 C 0 300 0 300 0 300 Q 0 300 0 300 "); stroke: #000; }
    50% { opacity: 1; d: path("M 0 300 Q 50 300 100 300 Q 250 300 350 300 C 350 300 500 300 650 300 Q 750 300 800 300"); stroke: var(--main-sub-color); }
    100% { opacity: 1; d: path("M -2 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 802 400"); stroke: var(--main-tertiary-color); }
  }
  
  @keyframes ContentFadeIn {
    0% { transform: translateY(-1rem); opacity: 0; }
    100% { transform: translateY(0); opacity: 1; }
  }
  
  @keyframes ImageFadeIn {
    0% { transform: translate(-.5rem, -.5rem) scale(1.05); opacity: 0; filter: blur(2px); }
    50% { opacity: 1; filter: blur(2px); }
    100% { transform: translateY(0) scale(1.0); opacity: 1; filter: blur(0); }
  }

  .sidemenu__footer {
    position: fixed;
    bottom: 15px;
  }

  .footer-btn-container {
    display: flex;
    justify-content: space-around;

  }

  .mobile__header {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .card {
      display: none;
    }
    .sidemenu__content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100vw;
      height: 5vh;
      background: #0C0C0B;
    }
    .sidemenu__footer {
      display: none;
    }
    .mobile__header {
      display: flex;
      width: 100vw;
      padding: 5px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: white;
      font-weight: 800;
      letter-spacing: 0.01em;
    }

  .logout-btn { 
    display: inline-block;
    outline: 0;
    cursor: pointer;
    border: 1px solid #1d1c1d4d;
    font-weight: 700;
    background: #E7E8E8;
    padding: 0 8px 1px;
    font-size: 13px;
    border-radius: 26px;
    border: 1px solid #D4D3E8;
    color: var(--main-sub-color);
    text-transform: uppercase;
    box-shadow: 0px 2px 2px var(--main-sub-color);
    height: 28px;
    min-width: 56px;
    transition: .2s;
  }
  .logout-btn:hover{
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);
        background: rgba(248,248,248,1);
    }
  }    

  .login__submit {
    background: #E7E8E8;
    font-size: 14px;
    margin-top: 30px;
    padding: 16px 20px;
    border-radius: 26px;
    border: 1px solid #D4D3E8;
    text-transform: uppercase;
    font-weight: 700;
    display: flex;
    align-items: center;
    color: var(--main-sub-color);
    box-shadow: 0px 2px 2px var(--main-sub-color);
    cursor: pointer;
    transition: .2s;
  }
  
  .login__submit:active,
  .login__submit:focus,
  .login__submit:hover {
    border-color: var(--main-tertiary-color);
    outline: none;
  }
`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":";;AAEA;EACE,cAAc;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,6CAA6C;IAC7C,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;EACA;QACM,uCAAuC;QACvC,+BAA+B;IACnC;;EAEF;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC;8BAC0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB;+CAC2C;EAC7C;;EAEA;IACE,eAAe;EACjB;IACE;MACE,8BAA8B;IAChC;;IAEA;IACA,UAAU;IACV,8CAA8C;IAC9C;;IAEA;MACE,UAAU;MACV,wCAAwC;IAC1C;;IAEA;MACE,oCAAoC;MACpC,aAAa;MACb,gBAAgB;MAChB,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,UAAU;MACV,0CAA0C;IAC5C;;IAEA;MACE,kBAAkB;MAClB,OAAO;MACP,UAAU;IACZ;;;EAGF;IACE,KAAK,UAAU,EAAE,iFAAiF,EAAE,YAAY,EAAE;IAClH,MAAM,UAAU,EAAE,iGAAiG,EAAE,6BAA6B,EAAE;IACpJ,OAAO,UAAU,EAAE,kGAAkG,EAAE,kCAAkC,EAAE;EAC7J;;EAEA;IACE,KAAK,4BAA4B,EAAE,UAAU,EAAE;IAC/C,OAAO,wBAAwB,EAAE,UAAU,EAAE;EAC/C;;EAEA;IACE,KAAK,gDAAgD,EAAE,UAAU,EAAE,iBAAiB,EAAE;IACtF,MAAM,UAAU,EAAE,iBAAiB,EAAE;IACrC,OAAO,mCAAmC,EAAE,UAAU,EAAE,eAAe,EAAE;EAC3E;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,6BAA6B;;EAE/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;MACnB,YAAY;MACZ,gBAAgB;MAChB,sBAAsB;IACxB;;EAEF;IACE,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,6CAA6C;IAC7C,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;QACM,uCAAuC;QACvC,+BAA+B;IACnC;EACF;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,6CAA6C;IAC7C,eAAe;IACf,eAAe;EACjB;;EAEA;;;IAGE,wCAAwC;IACxC,aAAa;EACf","sourcesContent":["\r\n\r\n.sidemenu {\r\n  position:fixed;\r\n    min-width: 300px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center; \r\n    z-index: 1000;\r\n  }\r\n\r\n  .sidemenu__header {\r\n    background: #A0A0A0;\r\n    color: white;\r\n    border-bottom: rgb(80, 80, 80) solid 0.5px;\r\n  }\r\n\r\n  .logout-btn { \r\n    display: inline-block;\r\n    outline: 0;\r\n    cursor: pointer;\r\n    border: 1px solid #1d1c1d4d;\r\n    font-weight: 700;\r\n    background: #E7E8E8;\r\n    padding: 0 8px 1px;\r\n    border-radius: 26px;\r\n    font-size: 13px;\r\n    border: 1px solid #D4D3E8;\r\n    color: var(--main-sub-color);\r\n    text-transform: uppercase;\r\n    box-shadow: 0px 2px 2px var(--main-sub-color);\r\n    height: 28px;\r\n    min-width: 56px;\r\n    transition: .2s;\r\n    margin-right: 10px;\r\n  }\r\n  .logout-btn:hover{\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);\r\n        background: rgba(248,248,248,1);\r\n    }\r\n\r\n  .sidemenu__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100vh;\r\n    background: var(--header-color);\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n  .card {\r\n    position: relative;\r\n    background: var(--header-card-color);\r\n    width: 300px;\r\n    border-radius: 6px;\r\n    padding: 2rem;\r\n    color: var(--header-card-text-color);\r\n    box-shadow: 0 .25rem .25rem rgba(0,0,0,0.2),\r\n      0 0 1rem rgba(0,0,0,0.2);\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n    line-height: 1.5;\r\n    font-family: \"HelveticaNeue-Light\", \"Helvetica Neue Light\", \"Helvetica Neue\", \r\n  Helvetica, Arial, \"Lucida Grande\", sans-serif;\r\n  }\r\n\r\n  img {\r\n    max-width: 100%;\r\n  }\r\n    .card__image-container {\r\n      margin: -2rem -2rem 1rem -2rem;\r\n    }\r\n    \r\n    .card__line {\r\n    opacity: 0;\r\n    animation: LineFadeIn .8s .8s forwards ease-in;\r\n    }\r\n  \r\n    .card__image {\r\n      opacity: 0;\r\n      animation: ImageFadeIn .8s 1.4s forwards;\r\n    }\r\n  \r\n    .card__title {\r\n      color: var(--header-card-text-color);\r\n      margin-top: 0;\r\n      font-weight: 800;\r\n      letter-spacing: 0.01em;\r\n    }\r\n    \r\n    .card__content {\r\n      margin-top: -1rem;\r\n      opacity: 0;\r\n      animation: ContentFadeIn .8s 1.6s forwards;\r\n    }\r\n    \r\n    .card__svg {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 115px;\r\n    }\r\n  \r\n  \r\n  @keyframes LineFadeIn {\r\n    0% { opacity: 0; d: path(\"M 0 300 Q 0 300 0 300 Q 0 300 0 300 C 0 300 0 300 0 300 Q 0 300 0 300 \"); stroke: #000; }\r\n    50% { opacity: 1; d: path(\"M 0 300 Q 50 300 100 300 Q 250 300 350 300 C 350 300 500 300 650 300 Q 750 300 800 300\"); stroke: var(--main-sub-color); }\r\n    100% { opacity: 1; d: path(\"M -2 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 802 400\"); stroke: var(--main-tertiary-color); }\r\n  }\r\n  \r\n  @keyframes ContentFadeIn {\r\n    0% { transform: translateY(-1rem); opacity: 0; }\r\n    100% { transform: translateY(0); opacity: 1; }\r\n  }\r\n  \r\n  @keyframes ImageFadeIn {\r\n    0% { transform: translate(-.5rem, -.5rem) scale(1.05); opacity: 0; filter: blur(2px); }\r\n    50% { opacity: 1; filter: blur(2px); }\r\n    100% { transform: translateY(0) scale(1.0); opacity: 1; filter: blur(0); }\r\n  }\r\n\r\n  .sidemenu__footer {\r\n    position: fixed;\r\n    bottom: 15px;\r\n  }\r\n\r\n  .footer-btn-container {\r\n    display: flex;\r\n    justify-content: space-around;\r\n\r\n  }\r\n\r\n  .mobile__header {\r\n    display: none;\r\n  }\r\n\r\n  @media only screen and (max-width: 600px) {\r\n    .card {\r\n      display: none;\r\n    }\r\n    .sidemenu__content {\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      width: 100vw;\r\n      height: 5vh;\r\n      background: #0C0C0B;\r\n    }\r\n    .sidemenu__footer {\r\n      display: none;\r\n    }\r\n    .mobile__header {\r\n      display: flex;\r\n      width: 100vw;\r\n      padding: 5px;\r\n      flex-direction: row;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      color: white;\r\n      font-weight: 800;\r\n      letter-spacing: 0.01em;\r\n    }\r\n\r\n  .logout-btn { \r\n    display: inline-block;\r\n    outline: 0;\r\n    cursor: pointer;\r\n    border: 1px solid #1d1c1d4d;\r\n    font-weight: 700;\r\n    background: #E7E8E8;\r\n    padding: 0 8px 1px;\r\n    font-size: 13px;\r\n    border-radius: 26px;\r\n    border: 1px solid #D4D3E8;\r\n    color: var(--main-sub-color);\r\n    text-transform: uppercase;\r\n    box-shadow: 0px 2px 2px var(--main-sub-color);\r\n    height: 28px;\r\n    min-width: 56px;\r\n    transition: .2s;\r\n  }\r\n  .logout-btn:hover{\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 8%);\r\n        background: rgba(248,248,248,1);\r\n    }\r\n  }    \r\n\r\n  .login__submit {\r\n    background: #E7E8E8;\r\n    font-size: 14px;\r\n    margin-top: 30px;\r\n    padding: 16px 20px;\r\n    border-radius: 26px;\r\n    border: 1px solid #D4D3E8;\r\n    text-transform: uppercase;\r\n    font-weight: 700;\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--main-sub-color);\r\n    box-shadow: 0px 2px 2px var(--main-sub-color);\r\n    cursor: pointer;\r\n    transition: .2s;\r\n  }\r\n  \r\n  .login__submit:active,\r\n  .login__submit:focus,\r\n  .login__submit:hover {\r\n    border-color: var(--main-tertiary-color);\r\n    outline: none;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
